export const environment = {
  firebaseConfig: {
    projectId: 'rusbeplatform',
    appId: '1:412058106218:web:089325259a6f47d1c40d13',
    storageBucket: 'rusbeplatform.firebasestorage.app',
    locationId: 'us-central',
    apiKey: 'AIzaSyBtsd8ViYqfl59A6PhhQsT6ddQ-b71zXh0',
    authDomain: 'rusbe.app',
    messagingSenderId: '412058106218',
    measurementId: 'G-S79FLBKKJM',
  },
  production: true,
  accountMailDomain: 'ufpe.br',
  archiveUrl: 'https://archive.rusbe.app',
  generalGoodsApiUrl: 'https://driving-willing-vulture.ngrok-free.app',
  sentryConfig: {
    dsn: 'https://103cdbceaf0b895e7ccb03cf7ad6c9e0@o4508938808852480.ingest.us.sentry.io/4508938813243392',
    integrations: [],
  },
};
